var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "podio" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-5 mb-3 mb-lg-0" }, [
        _c(
          "p",
          { staticClass: "podio-regra" },
          [
            _vm._v("\n          As "),
            _c("b", [_vm._v(_vm._s(_vm.dados.top))]),
            _vm._v(" revendedoras com mais unidades ganham"),
            _vm.dados.minimo_mes
              ? [
                  _vm._v(",\n          com no mínimo "),
                  _c("b", [_vm._v(_vm._s(_vm.dados.minimo_mes))]),
                  _vm._v(" unidades em cada mês")
                ]
              : _vm._e(),
            _vm._v(".\n        ")
          ],
          2
        ),
        _vm._v(" "),
        _vm.meu
          ? _c(
              "div",
              {
                staticClass: "podio-meu",
                class: "podio-meu--" + _vm.estadoMeu
              },
              [
                _c("div", { staticClass: "podio-meu-pos" }, [
                  _c("span", { staticClass: "podio-meu-num" }, [
                    _vm._v(
                      _vm._s(_vm.meu.posicao ? _vm.meu.posicao + "º" : "—")
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "podio-meu-rotulo" }, [
                    _vm._v(
                      _vm._s(
                        _vm.meu.posicao ? "sua posição" : "fora do ranking"
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "podio-meu-info" }, [
                  _c("div", [
                    _c("strong", [_vm._v(_vm._s(_vm.meu.total_unidades))]),
                    _vm._v(" unidade(s) no total\n            ")
                  ]),
                  _vm._v(" "),
                  _vm.estadoMeu === "premiada" && _vm.meu.premio
                    ? _c("div", [
                        _vm._v("\n              Prêmio atual: "),
                        _c("strong", [_vm._v(_vm._s(_vm.meu.premio))])
                      ])
                    : _vm.meu.falta_top !== null &&
                      _vm.meu.falta_top !== undefined
                    ? _c("div", [
                        _vm._v("\n              Faltam "),
                        _c("strong", [_vm._v(_vm._s(_vm.meu.falta_top))]),
                        _vm._v(
                          " unidade(s) para o " +
                            _vm._s(_vm.dados.top) +
                            "º lugar\n            "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "podio-meses" },
                    _vm._l(_vm.dados.meses, function(mes, i) {
                      return _c(
                        "span",
                        {
                          key: mes,
                          staticClass: "podio-mes",
                          class: {
                            "podio-mes--ok": _vm.bateuMes(
                              _vm.meu.unidades_mes[i]
                            )
                          }
                        },
                        [
                          _vm.bateuMes(_vm.meu.unidades_mes[i])
                            ? _c("i", { staticClass: "fas fa-check mr-1" })
                            : _vm._e(),
                          _vm._v("\n                " + _vm._s(mes) + " "),
                          _c("b", [
                            _vm._v(_vm._s(_vm.meu.unidades_mes[i] || 0))
                          ]),
                          _vm.dados.minimo_mes
                            ? [_vm._v("/" + _vm._s(_vm.dados.minimo_mes))]
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("small", { staticClass: "podio-meu-situacao" }, [
                    _vm._v(_vm._s(_vm.meu.situacao))
                  ])
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.podio.length
          ? _c(
              "div",
              { staticClass: "podio-degraus" },
              _vm._l(_vm.podio, function(item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "podio-degrau",
                    class: [
                      "podio-degrau--" + item.posicao,
                      { "podio-degrau--eu": _vm.ehEu(item) }
                    ]
                  },
                  [
                    _c("div", { staticClass: "podio-medalha" }, [
                      _vm._v(_vm._s(item.posicao) + "º")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "podio-nome",
                        attrs: { title: item.nome }
                      },
                      [_vm._v(_vm._s(item.nome))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "podio-cidade" }, [
                      _vm._v(_vm._s(item.cidade) + "/" + _vm._s(item.uf))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "podio-bloco" }, [
                      _c("span", { staticClass: "podio-bloco-num" }, [
                        _vm._v(_vm._s(item.total_unidades))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "podio-bloco-un" }, [
                        _vm._v("unidades")
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.dados.faixas.length
          ? _c(
              "div",
              { staticClass: "podio-faixas" },
              [
                _c("div", { staticClass: "podio-faixas-titulo" }, [
                  _vm._v("Prêmios")
                ]),
                _vm._v(" "),
                _vm._l(_vm.dados.faixas, function(f, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      staticClass: "podio-faixa",
                      class: "podio-faixa--" + i
                    },
                    [
                      _c("span", { staticClass: "podio-faixa-pos" }, [
                        _vm._v(_vm._s(f.de) + "º a " + _vm._s(f.ate) + "º")
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(f.premio))])
                    ]
                  )
                })
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-7" },
        [
          _c(
            "b-tabs",
            { attrs: { "content-class": "mt-3", small: "" } },
            [
              _c(
                "b-tab",
                { attrs: { title: "Top " + _vm.dados.top, active: "" } },
                [
                  _c(
                    "div",
                    { staticClass: "podio-busca" },
                    [
                      _c("b-form-input", {
                        attrs: {
                          size: "sm",
                          placeholder: "Buscar revendedora ou cidade"
                        },
                        model: {
                          value: _vm.busca,
                          callback: function($$v) {
                            _vm.busca = $$v
                          },
                          expression: "busca"
                        }
                      }),
                      _vm._v(" "),
                      _vm.meu &&
                      _vm.meu.posicao &&
                      _vm.meu.posicao <= _vm.dados.top
                        ? _c(
                            "b-button",
                            {
                              attrs: { size: "sm", variant: "outline-primary" },
                              on: { click: _vm.irParaMim }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-crosshairs mr-1"
                              }),
                              _vm._v("Minha posição\n          ")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { ref: "lista", staticClass: "podio-lista" }, [
                    _c("table", { staticClass: "table table-sm mb-0" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v("#")
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Revendedora")]),
                          _vm._v(" "),
                          _c("th", { staticClass: "d-none d-md-table-cell" }, [
                            _vm._v("Cidade")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-right" }, [
                            _vm._v("Unid.")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "d-none d-sm-table-cell" }, [
                            _vm._v("Prêmio")
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.rankingFiltrado, function(item) {
                            return _c(
                              "tr",
                              {
                                key: item.id,
                                ref: "linha" + item.id,
                                refInFor: true,
                                class: [
                                  "podio-linha--" + _vm.faixaDe(item.posicao),
                                  { "podio-linha--eu": _vm.ehEu(item) }
                                ]
                              },
                              [
                                _c(
                                  "td",
                                  { staticClass: "text-center podio-pos" },
                                  [_vm._v(_vm._s(item.posicao) + "º")]
                                ),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(item.nome))]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "d-none d-md-table-cell" },
                                  [
                                    _vm._v(
                                      _vm._s(item.cidade) +
                                        "/" +
                                        _vm._s(item.uf)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-right" }, [
                                  _c("b", [_vm._v(_vm._s(item.total_unidades))])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "d-none d-sm-table-cell podio-premio"
                                  },
                                  [_vm._v(_vm._s(item.premio))]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          !_vm.rankingFiltrado.length
                            ? _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-center text-muted py-3",
                                    attrs: { colspan: "5" }
                                  },
                                  [_vm._v("Nenhuma revendedora encontrada.")]
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.dados.rede.length
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        title: "Sua rede (" + _vm.dados.rede.length + ")"
                      }
                    },
                    [
                      _c("p", { staticClass: "podio-rede-resumo" }, [
                        _c("b", [_vm._v(_vm._s(_vm.dados.rede.length))]),
                        _vm._v(
                          " revendedora(s) da sua rede participando,\n          "
                        ),
                        _c("b", [_vm._v(_vm._s(_vm.redeNoTop))]),
                        _vm._v(
                          " entre as " +
                            _vm._s(_vm.dados.top) +
                            " primeiras.\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "podio-lista" }, [
                        _c("table", { staticClass: "table table-sm mb-0" }, [
                          _c("thead", [
                            _c(
                              "tr",
                              [
                                _c("th", { staticClass: "text-center" }, [
                                  _vm._v("#")
                                ]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Revendedora")]),
                                _vm._v(" "),
                                _vm._l(_vm.dados.meses, function(mes) {
                                  return _c(
                                    "th",
                                    {
                                      key: mes,
                                      staticClass:
                                        "text-center d-none d-lg-table-cell"
                                    },
                                    [_vm._v(_vm._s(mes))]
                                  )
                                }),
                                _vm._v(" "),
                                _c("th", { staticClass: "text-right" }, [
                                  _vm._v("Total")
                                ]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Prêmio / situação")])
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.dados.rede, function(item) {
                              return _c(
                                "tr",
                                {
                                  key: item.id,
                                  class:
                                    "podio-linha--" + _vm.faixaDe(item.posicao)
                                },
                                [
                                  _c(
                                    "td",
                                    { staticClass: "text-center podio-pos" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.posicao
                                            ? item.posicao + "º"
                                            : "—"
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.nome))]),
                                  _vm._v(" "),
                                  _vm._l(_vm.dados.meses, function(mes, i) {
                                    return _c(
                                      "td",
                                      {
                                        key: mes,
                                        staticClass:
                                          "text-center d-none d-lg-table-cell",
                                        class: {
                                          "text-success font-weight-bold": _vm.bateuMes(
                                            item.unidades_mes[i]
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(item.unidades_mes[i] || 0)
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _c("b", [
                                      _vm._v(_vm._s(item.total_unidades))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "podio-premio" },
                                    [
                                      item.posicao &&
                                      item.posicao <= _vm.dados.top
                                        ? [_vm._v(_vm._s(item.premio))]
                                        : _c(
                                            "small",
                                            { staticClass: "text-muted" },
                                            [_vm._v(_vm._s(item.situacao))]
                                          )
                                    ],
                                    2
                                  )
                                ],
                                2
                              )
                            }),
                            0
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ebe1134", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ebe1134","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Home/PodioHome.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0ebe1134","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/Home/PodioHome.vue
// module chunks = 2